import { encodePaginatableQuery, PaginatableQuery, Query } from '@/services/api';
import * as q from '@/services/api/request/query';

export enum VALIDATION_RESULT {
  POSITIVE = 1,
  NEGATIVE = 0,
}

export interface AiPhotoValidationListParams extends PaginatableQuery {
  search?: string;
  validationResult?: VALIDATION_RESULT;
  confidenceMin?: number;
  confidenceMax?: number;
}

export const encodeAiPhotoValidationQuery = (query: AiPhotoValidationListParams): Query => ({
  ...encodePaginatableQuery(query),
  search: q.nullableString(query.search || null),
  validationResult: q.nullableString(query.validationResult?.toString() || null),
  confidenceMin: q.nullableNumber(query.confidenceMin || null),
  confidenceMax: q.nullableNumber(query.confidenceMax || null),
});
